import Icon from '@ant-design/icons';
import { Layout, Menu } from 'antd';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Outlet, useLocation, useNavigate } from 'react-router';
import {
  SVGTemplate,
  SVGFlow,
  SVGMachine,
  SVGDiagnose,
  SVGPeople,
  SVGSkill,
} from '../../images';

export const menus = [
  {
    key: 'diagnose',
    label: 'Diagnose (Coming soon)',
    icon: <Icon component={SVGDiagnose} />,
  },
  {
    key: 'people',
    label: 'People (Coming soon)',
    icon: <Icon component={SVGPeople} />,
  },
  {
    key: 'skillset',
    label: 'Skillset (Coming soon)',
    icon: <Icon component={SVGSkill} />,
  },
];

const Insight = () => {
  const { t } = useTranslation();
  const location = useLocation();
  const navigate = useNavigate();

  const { pathname } = location;

  const selectedKeys = pathname.split('/').slice(2);

  const [defaultOpenKeys, setDefaultOpenKeys] = useState<string[]>([]);

  return (
    <Layout style={{ height: '100%' }}>
      <Layout.Sider style={{ backgroundColor: '#3d5727' }}>
        <Menu
          selectedKeys={selectedKeys}
          defaultOpenKeys={defaultOpenKeys}
          theme="light"
          items={menus}
          onClick={({ key, keyPath }) => {
            navigate(key);
            setDefaultOpenKeys(keyPath);
          }}
        />
      </Layout.Sider>
      <Layout.Content>
        <Outlet />
      </Layout.Content>
    </Layout>
  );
};

export default Insight;
